import React, { useEffect, useState } from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import styles from './MediaType.module.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  scales: {
    // scaleShowLabels: false,
    x: {  // <-- axis is not array anymore, unlike before in v2.x: '[{'
      grid: {
        color: '#151515',
        // borderColor: 'red'  // <-- this line is answer to initial question
      },
      ticks: {
        color: '#ded9c4'
      }
      // display: false
    },
    y: {  // <-- axis is not array anymore, unlike before in v2.x: '[{'
      grid: {
        color: '#151515',
        // borderColor: 'green'  // <-- this line is answer to initial question
      },
      display: false
    }
  },
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      display: false
    },
    title: {
      display: false,
      text: '',
    },
  },
};

// const labels = ['Pencil', 'Pen', 'Wash', 'Color', 'Paint'];

const tempMD = [
  {
      "media": "pencil",
      "count": 58
  },
  {
      "media": "pen",
      "count": 17
  },
  {
      "media": "color",
      "count": 9
  },
  {
      "media": "wash",
      "count": 6
  },
  {
    "media": "paint",
    "count": 2
}
];

const tempMD2 = [
  58,
  17,
  9,
  6,
  2
]

const MediaBar = (props) => {
  const [mediaTypes, setMediaTypes] = useState(tempMD);

  // console.log('check', tempMD.map(e => e.count));

  let data = {
    labels: props.mediaTypeArray.map(e => e.media),
    datasets: [
      {
        label: '',
        data: mediaTypes.map(e => e.count),
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      }
    ],
  };

  useEffect(() => {
    setMediaTypes(props.mediaTypeArray.map(e => e.count));
    // console.log('props.mediaTypeArray', props.mediaTypeArray);
  }, [props.mediaTypeArray]);

  data = {
    labels: props.mediaTypeArray.map(e => e.media),
    datasets: [
      {
        label: '',
        data: props.mediaTypeArray.map(e => e.count),
        backgroundColor: ['#5D534A',
        '#0A81AB',
        '#BB371A',
        '#EBA83A',
        '#8B5E83'],
      }
    ],
  };

  return (
    <div className={styles.categoriesContainer}>
      <div className={styles.pieDiv}>
        <Bar data={data} options={options} />
      </div>
    </div>
    
  );
};

export default MediaBar;
